module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-page-navigation-left-arrow-default.cf8a8b84.svg";